import Modal from '../../atoms/Modal';
import StateView from '../../atoms/State';
import useLoader from '../../hooks/useLoader';
import { BaseModalData } from '../../types/Modals';
import { CompanyId } from '../../types/Types';
import { CompanyEditPage } from './index';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export interface CompanyEditModalData extends BaseModalData {
    id: CompanyId;
}

const initialStyle = {
    content: {
        minHeight: 438
    }
};

export function CompanyEditModal(props: {
    onClose: () => void;
    data: CompanyEditModalData;
    index: number;
    onFocus: VoidFunction;
}) {
    const { t } = useTranslation();
    const { state, revalidate } = useLoader(
        useCallback((x) => x.loadCompanyForEditing(props.data.id), [props.data.id])
    );
    return (
        <Modal
            index={props.index}
            onFocus={props.onFocus}
            onClose={props.onClose}
            styles={initialStyle}
            maw={800}
            title={
                props.data.title ??
                (state.type === 'done' && state.data.company?.name
                    ? t('modal.companyEdit.titleWithName', { name: state.data.company.name })
                    : t('modal.companyEdit.titleWithoutName'))
            }>
            <StateView state={state} retry={revalidate}>
                {(data) => <CompanyEditPage companyEdit={data} handleClose={props.onClose} />}
            </StateView>
        </Modal>
    );
}
